import React, { useContext } from "react";
import constants from "../../../constants";
import AttemptCard from "./AttemptScoreCard";
import GraphForAttempts from "./GraphForAttempts";
import DropdownIcon from "../../../Svg/DropdownIcon";
import { MockTestPageContext } from "../../../context/MockTestPageContext";
import MockTestResultsHooks from "../../../Hooks/Mock/Student/MockTestResultsHooks";
import CompanySpecificResultsDetails from "../../../Hooks/Mock/Student/CompanySpecificResultDetails";

export default function CompanySpecificResults() {
  const MockTestPageCxt = useContext(MockTestPageContext);

  const MockTestResultsHks = MockTestResultsHooks();

  CompanySpecificResultsDetails();

  return (
    <div className="mockTestResultsMainContainer">
      <table className="mockTestResultsTable">
        <thead>
          <tr>
            <th className="mockTestResultsName">Test Name</th>
            <th className="mockTestResultsType">Type</th>
            <th className="mockTestResultsScore">Score</th>
            <th className="mockTestResultsLastAttempt">Last Attempt</th>
            <th className="mockTestResultsAttempts">Attempts</th>
            <th className="dropDownIconHeader"></th>
          </tr>
        </thead>
        <tbody>
          {MockTestPageCxt.searchMockTest.map((test) => (
            <React.Fragment key={test.tid || test.id}>
              <tr
                className="mockTestRow"
                onClick={() =>
                  MockTestResultsHks.toggleRow(test.tid || test.id)
                }
              >
                <td className="mockTestResultsRowName">
                  {test.name || test.lpname}
                </td>
                <td className="mockTestResultsRowType">
                  {MockTestResultsHks.findFileType(
                    test.libtype,
                    test.isVideoQn ?? test.videoqn,
                    test.aiMode
                  )}
                </td>
                <td className="mockTestResultsRowScore">
                  {(() => {
                    let lastActualScore = "-";
                    let lastTargetScore = "-";

                    if (test.attempteddata) {
                      try {
                        const parsedData = JSON.parse(test.attempteddata);

                        if (
                          Array.isArray(parsedData) &&
                          parsedData.length > 0
                        ) {
                          lastActualScore =
                            parsedData[parsedData.length - 1].actualscore;

                          lastTargetScore =
                            parsedData[parsedData.length - 1].targetscore;

                          lastActualScore =
                            lastActualScore < 0 ? "-" : lastActualScore;
                        }
                      } catch (error) {
                        console.error("Error parsing attempteddata:", error);
                      }
                    }

                    return (test.libtype === constants.libTypeIds.DESCRIPTIVE ||
                      test.libtype === constants.libTypeIds.CODING_SNIPPET) &&
                      (test.autoeval === 1 ||
                        (test.isVideoQn ?? test.videoqn) === 1)
                      ? "-"
                      : `${lastActualScore}/${lastTargetScore}`;
                  })()}
                </td>
                <td className="mockTestResultsRowLastDate">
                  {(() => {
                    let lastSubmittedDate = "-";

                    if (test.attempteddata) {
                      try {
                        const parsedData = JSON.parse(test.attempteddata);

                        if (
                          Array.isArray(parsedData) &&
                          parsedData.length > 0
                        ) {
                          lastSubmittedDate =
                            parsedData[parsedData.length - 1].submitteddate;
                        }
                      } catch (error) {
                        console.error("Error parsing attempteddata:", error);
                      }
                    }

                    return MockTestResultsHks.getSubmittedDate(
                      lastSubmittedDate
                    );
                  })()}
                </td>
                <td className="mockTestResultsRowAttempts">
                  {(() => {
                    let totalAttempts = "0";

                    if (test.attempteddata) {
                      try {
                        const parsedData = JSON.parse(test.attempteddata);

                        if (
                          Array.isArray(parsedData) &&
                          parsedData.length > 0
                        ) {
                          totalAttempts = parsedData.length;
                        }
                      } catch (error) {
                        console.error("Error parsing attempteddata:", error);
                      }
                    }

                    return totalAttempts;
                  })()}
                </td>
                <td className="dropdownIconWrapper">
                  <DropdownIcon />
                </td>
              </tr>

              {MockTestResultsHks.expandedRow === (test.tid || test.id) && (
                <tr className="expandedRow">
                  <td colSpan={6}>
                    <div className="expandedContent">
                      <div className="attemptCardsDiv">
                        {test.attempteddata &&
                          (() => {
                            try {
                              const parsedData = JSON.parse(test.attempteddata);

                              return parsedData.map((attempt, index) => {
                                const formattedScore =
                                  attempt.actualscore < 0
                                    ? `-/${attempt.targetscore}`
                                    : `${attempt.actualscore}/${attempt.targetscore}`;

                                return (
                                  <AttemptCard
                                    key={index}
                                    test={test}
                                    attemptNo={attempt.atmptcount}
                                    score={formattedScore}
                                    date={attempt.submitteddate}
                                  />
                                );
                              });
                            } catch (error) {
                              console.error(
                                "Error parsing attempteddata:",
                                error
                              );
                              return <p>Error loading attempts</p>;
                            }
                          })()}
                      </div>

                      <div className="chart-container">
                        {test.attempteddata &&
                          (() => {
                            try {
                              const parsedData = JSON.parse(test.attempteddata)
                                .filter((attempt) => attempt.actualscore >= 0) // Only include non-negative scores
                                .map((attempt, index) => ({
                                  attempt: index + 1,
                                  score: attempt.actualscore,
                                  targetscore: attempt.targetscore,
                                }));

                              // Only show UI if there are more than 1 valid attempts
                              if (parsedData.length > 1) {
                                return (
                                  <>
                                    <div className="top-section">
                                      <div className="attempt-numbers">
                                        {Array.from(
                                          { length: parsedData.length },
                                          (_, i) => (
                                            <span key={i}>{i + 1}</span>
                                          )
                                        )}
                                      </div>
                                    </div>

                                    <GraphForAttempts
                                      attemptedData={parsedData}
                                    />
                                  </>
                                );
                              } else {
                                return <></>;
                              }
                            } catch (error) {
                              console.error(
                                "Error parsing attempteddata:",
                                error
                              );
                              return <p>Error loading data</p>;
                            }
                          })()}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
